import { render } from "./Dashboard.vue?vue&type=template&id=aefb1442"
import script from "./Dashboard.vue?vue&type=script&lang=js"
export * from "./Dashboard.vue?vue&type=script&lang=js"

import "./Dashboard.vue?vue&type=style&index=0&id=aefb1442&lang=css"

import exportComponent from "/media/alvian/New Volume/project/vue js/sample-inc-web-report/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__